import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, servico } = obj
  const response = await http[verb]('/servicos', servico)

  if (response !== null) {
    // console.log('actions.js - Line 9: ' + JSON.stringify(response))

    servico.id = response.data.data.id
    update(context, { ...servico })
    return Promise.resolve()
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/servicos/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const getBanks = async (context) => {
  const response = await http.get('https://www.febraban.org.br/associados/utilitarios/bancos.asp')
  if (response !== null) {
    let banksObject = []
    let html = this.$(response.data)
    let banksHtml = html.find('tbody tr:nth-child(n+5)')

    banksHtml.each((index, element) => {
      let objectAux = {}
      let columns = this.$(element).find('td:nth-child(-n + 2)')

      columns.each((index, element) => {
        if (index === 0) {
          objectAux['code'] = this.$.trim(this.$(element).text()).replace(/[-!$%^&*()_+|~=`{}\]:";<>?,.@#]/gm, '')

          return true
        }

        objectAux['name'] = this.$.trim(this.$(element).text())
      })

      if (!objectAux.code) {
        return true
      }

      banksObject.push(objectAux)
    })

    return Promise.resolve(banksObject)
  }
}

const fetch = async ({ commit }) => {
  const response = await http.get('/servicos')
  if (response !== null) {
    const servicos = response.data
    commit('SET_LIST', servicos)
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { servicos: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/servicos/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove,
  getBanks
}



// WEBPACK FOOTER //
// ./src/features/admin/servicos/store/actions.js